import { Component, Host, h, Prop, State, Watch } from '@stencil/core';
import '../header-component/header-component'
import '../loader-component/loader-component'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import $ from "jquery";

/**
 


#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/about-component.PNG)

#### Content Type
nypwebc_ct_about

 */
@Component({
  tag: 'bootstrap-blank-component',
  styleUrl: 'bootstrap-blank-component.css',
  scoped: true
})

export class BootstrapBlankComponent {

  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";



  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";


  /**
   *Optional - To show/hide header - default is true
   */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;


  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
*Optional -header text color
*/
  @Prop() headertextcolor: string = "black"
  /**
*Optional -header border bottom css
*/
  @Prop() headerborderbottom: string = "1px solid #CE2127"

  /**
*Optional -html fragment
*/
  @Prop() html: string = ""
  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;



  @State() isLoading: boolean = true
  @State() items: []

  componentDidLoad() {

    this.isLoading = false;
  }

  getContents = () => {
    const contentsArray = []
    contentsArray.push(<div style={{padding:"10px",fontSize:"16px"}} innerHTML={this.html} />)
    return contentsArray
  }

  render() {
    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px"
      }
    }


    return (
      this.isLoading ?
        <loader-component /> :
        this.header ?
          <div >
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
            <div class="row gx-0" style={parentstyle} >
              <div style={styleWithHeader}>
                {this.getContents()}
              </div>
            </div>
          </div>
          :
          <div class="row gx-0" style={parentstyle} >
            <div style={style}>
              {this.getContents()}
            </div>
          </div>

    )



  }

}
